import VueTippy from 'vue-tippy'
import 'tippy.js/animations/scale.css'
import '@/plugins/app@components/vue-tippy/styles.css'

// Config for Vue tippy object
// For all props see:
// https://vue-tippy.netlify.app/props
const defaultWezeoOptions = {
	directive: 'tippy', // => v-tippy
	component: 'tippy', // => <tippy/>
	componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
	defaultProps: {
		placement: 'bottom',
		arrow: '<svg width="23" height="22" viewBox="0 0 23 22" xmlns="http://www.w3.org/2000/svg"><rect x="11.166" width="15.5563" height="15.5563" transform="rotate(45 11.166 0)" fill="white"/></svg>',
		delay: [100, 100],
		theme: 'custom-theme',
		animation: 'scale',
		touch: true,
		trigger: 'mouseenter',
	}
}

import { App } 				from 'vue'

export default {
	install: (app: App, options: Object) => {
		app.use(VueTippy, {...defaultWezeoOptions, ...options})
	}
}

